import { UPDATE_MODEL_VISIBILITY } from "api"; // Ensure this is defined correctly in your api.ts or similar file
import { fetch } from "libs"; // Assuming this is your custom fetch utility

// Function to update model visibility
export const updateModelVisibility = async (modelId: string, visible: boolean) => {
  const url = `${UPDATE_MODEL_VISIBILITY}/${modelId}`; // Make sure to construct the URL correctly

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ visible }),
  });

  if (!response.ok) {
    throw new Error("Failed to update model visibility");
  }

  return response.json();
};
export default updateModelVisibility;
